import React, { useState } from 'react';
import axios from 'axios';

const AddTask = ({ onAdd }) => {
  const [task, setTask] = useState({
    title: '',
    description: '',
    completed: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTask((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post('http://localhost:8080/api/tasks/add', task)
      .then((response) => {
        onAdd(response.data);
        setTask({ title: '', description: '', completed: false });
      })
      .catch((error) => console.log(error));
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="text"
        name="title"
        value={task.title}
        onChange={handleChange}
        placeholder="Task Title"
        required
      />
      <input
        type="text"
        name="description"
        value={task.description}
        onChange={handleChange}
        placeholder="Task Description"
        required
      />
      <button type="submit">Add Task</button>
    </form>
  );
};

export default AddTask;
